import { Plus } from "lucide-react";
import { type RouteComponentProps } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { WFPButton } from "@/components/ui/button";

export const onClickAddNewContent = (
  history: RouteComponentProps["history"],
  contentType?: string
) => {
  history.push("/wfpManager/infohub/newContent", contentType ? { contentType } : undefined);
};

export const AddNewContentButton = ({ history }: { history: RouteComponentProps["history"] }) => {
  const { t } = useTranslation();
  return (
    <WFPButton type="button" onClick={() => onClickAddNewContent(history)}>
      <Plus />
      {t("infoHub.newMessage")}
    </WFPButton>
  );
};

export default AddNewContentButton;
